module.exports = __webpack_public_path__ + "static/media/welcome-logo.b54b6242.png";